// rounds number to nearest integer and returns it displayed
// in local number format
function format_number(number) {
  number = parseInt(number);
  return number.toLocaleString();
}

module.exports = { format_number }
